module.exports = __webpack_public_path__ + "img/Toggle-Off-Disabled.8a5295b8.svg";